import { render, staticRenderFns } from "./team-copy.vue?vue&type=template&id=689dc997&"
import script from "./team-copy.vue?vue&type=script&lang=ts&"
export * from "./team-copy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports